import axios from 'axios'
import Vue from 'vue'
import moment from 'moment'
import Form from '../components/MastodonForm.vue'
import parseLink from 'parse-link-header'
import get from 'lodash/get'

export const SCOPES = "read:accounts read:favourites read:follows"

export function favoritesToRetribute (favorites, cache) {
  if (!cache.profiles) {
    cache.profiles = {}
  }
  favorites.forEach(f => {
    const profileId = `webfinger:${f.account.acct}`
    if (cache.profiles[profileId]) {
      cache.profiles[profileId].weight += 1
    } else {
      cache.profiles[profileId] = {weight: 1}
    }
  });
  return cache
}

export function getAxios(url) {

}

export async function createApp(ax, {baseUrl, scopes}) {
  const payload = {
    client_name: `Retribute ${window.location.hostname}`,
    website: baseUrl,
    scopes,
    redirect_uris: `${baseUrl}/connect/mastodon/callback`
  }
  const response = await ax.post('/api/v1/apps', payload)
  return response
}


export default {
  id: "mastodon",
  label: "Mastodon",
  url: "https://joinmastodon.org",
  description: "Mastodon and compatible servers",
  extendedDescription: "Receive suggestions based on your favorites",
  imageBackground: "blue-grey darken-4",
  form: Form,
  connect: true,
  getLogo () {
    return require("../assets/sources/mastodon-logo.svg")
  },
  authDataToKey ({username, domain}) {
    return `mastodon ${domain} ${username}`
  },
  getAvatar (data) {
    if (!data.raw) {
      return null
    }
    return data.raw.avatar
  },
  getDisplayName ({username, domain}) {
    return `${username}@${domain}`
  },
  async handleCallback({query, router, store, baseUrl}) {
    const domain = query.state
    console.log(`Received connect callback for mastodon domain ${domain}`)
    console.log('Fetching token...')
    const app = store.state.sources.mastodon.appCredentials[domain]
    const ax = axios.create()
    const payload = {
      client_id: app.client_id,
      client_secret: app.client_secret,
      grant_type: "authorization_code",
      code: query.code,
      redirect_uri: `${baseUrl}/connect/mastodon/callback`
    }
    const response = await ax.post(`https://${domain}/oauth/token`, payload)
    const token = response.data.access_token
    const client = axios.create({
      baseURL: `https://${domain}`,
      headers: {'Authorization': `Bearer ${token}`},
    })
    const accountResponse = await client.get('/api/v1/accounts/verify_credentials')
    const username = `${accountResponse.data.acct}@${domain}`
    store.commit('setRecursiveState', {key: "sources.mastodon.appTokens", suffix: username, value: response.data})
    store.commit('addAccount', {source: 'mastodon', raw: accountResponse.data, username: accountResponse.data.acct, domain})
    router.push({path: '/'})
  },
  async fetch ({account, store, results, maxDays}) {
    results.status = `Fetching favorites...`
    const token = store.state.sources.mastodon.appTokens[`${account.username}@${account.domain}`].access_token
    const client = axios.create({
      baseURL: `https://${account.domain}`,
      headers: {'Authorization': `Bearer ${token}`},
    })
    const dateLimit = moment().subtract(maxDays, 'days')
    let url = '/api/v1/favourites'
    let handledFavorites = 0
    // results.progress = 0
    // results.progressCount
    results.accounts = {}
    let tooOld = 0
    let maxOld = 5
    while (tooOld < maxOld) {
      let response = await client.get(url, {params: {limit: 40}})
      response.data.forEach((f) => {
        let date = moment(f.created_at)
        // ugly hack because we don't have any way to query favorite date, and mastodon
        // return toots in reverse favorite date order, so favoriting a very old toot
        // can result in little to no suggestions
        if (date.isBefore(dateLimit)) {
          tooOld += 1
        } else {
          // we reset the counter
          tooOld = 0
        }
        handledFavorites += 1
        results.progressCount += 1
        let accountId = `activitypub:${f.account.url}`

        if (results.accounts[accountId]) {
          results.accounts[accountId].weight += 1
          let detail = get(results.accounts[accountId], 'detail', {})
          let mastodonDetail = get(detail, 'mastodon', {favorites: 0})
          mastodonDetail.favorites += 1
        } else {
          Vue.set(results.accounts, accountId, {
            weight: 1,
            source: 'activitypub',
            id: f.account.url,
            avatar: f.account.avatar,
            name: f.account.display_name,
            url: f.account.url,
            detail: {
              mastodon: {
                favorites: 1
              }
            }
          })
        }
        // results.progress = Math.min(100, handledFavorites / maxFavorites * 100)
      })
      let link = response.headers.link || ''
      let parsed = parseLink(link)
      if (parsed && parsed.next) {
        url = parsed.next.url
      } else {
        break
      }
      results.status = `Fetched ${handledFavorites} favorites`
    }
    results.isLoading = false
    return results
  },
  getDetailMessage (detail) {
    if (!detail) {
      return
    }
    let favorites = detail.favorites || 0
    return `Mastodon: ${favorites} favorites`
  }
}
